"use client";
import { jsx as i } from "react/jsx-runtime";
import { forwardRef as b, useMemo as x, Children as N, isValidElement as R, cloneElement as g } from "react";
import { splitResponsiveVariant as w, css as z, cx as E } from "@/styled-system/css";
import { useId as V } from "../../hooks/use-id.js";
import { iconRecipe as j } from "./icon.styles.js";
import { Slot as A } from "../../node_modules/.pnpm/@radix-ui_react-slot@1.1.0_@types_react@18.3.16_react@18.3.1/node_modules/@radix-ui/react-slot/dist/index.js";
const M = b(
  (c, l) => {
    const {
      children: o,
      className: a,
      css: d,
      focusable: m = !1,
      role: p = "img",
      render: r,
      size: f,
      title: e,
      ...h
    } = c, u = w("size", f), v = z(j.raw({ ...u }), d), n = V(), y = r || o ? A : "svg", C = x(() => {
      var t;
      if (!e)
        return r ?? o;
      const I = /* @__PURE__ */ i("title", { id: n, children: e }), s = N.toArray(r ?? o)[0];
      return R(s) ? (
        // Cloning a RSC overrides internal children
        // so we spread its children (the svg paths) onto the clone
        g(s, void 0, I, ...((t = s.props) == null ? void 0 : t.children) ?? [])
      ) : null;
    }, [e, n, r, o]);
    return /* @__PURE__ */ i(
      y,
      {
        "aria-labelledby": e ? n : void 0,
        "aria-hidden": e ? "false" : "true",
        className: E("c11n", v, a),
        "data-c11n-component": "Icon",
        "data-c11n-version": "10.0.0-alpha.19",
        focusable: m,
        ref: l,
        role: p,
        ...h,
        children: C
      }
    );
  }
);
M.displayName = "Icon";
export {
  M as Icon
};
//# sourceMappingURL=icon.js.map
